import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Client, CreateClientDto, UpdateClientDto } from '../models/client.model';

@Injectable({ providedIn: 'root' })
export class ClientsService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Clients`;

  getAll(): Observable<Client[]> {
    return this.http.get<Client[]>(this.base).pipe(catchError(this.handle));
  }

  getById(id: string): Observable<Client> {
    return this.http.get<Client>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  create(dto: CreateClientDto): Observable<Client> {
    return this.http.post<Client>(this.base, dto).pipe(catchError(this.handle));
  }

  update(id: string, dto: UpdateClientDto): Observable<Client> {
    return this.http.put<Client>(`${this.base}/${id}`, dto).pipe(catchError(this.handle));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  activeCount(): Observable<number> {
    return this.http.get<{ count: number }>(`${this.base}/active-count`).pipe(
      catchError(this.handle),
      // map the wrapped count to a number
      (source$) => new Observable<number>((subscriber) => {
        const subscription = source$.subscribe({
          next: (res) => subscriber.next(res.count),
          error: (e) => subscriber.error(e),
          complete: () => subscriber.complete(),
        });
        return () => subscription.unsubscribe();
      })
    );
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
